import {EntityDescriptionElementApiModel} from "./entity-description.element.api-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";

export class EntityDescriptionElementDomainModel extends BaseDomainModel {
  apiModel: EntityDescriptionElementApiModel;

  constructor(model: EntityDescriptionElementApiModel) {
    super(model);

    this.name = model.name;
    this.value = model.value;
  }
}
